import { FC, useEffect, useCallback } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { RouteProps } from './types';
import { MOBILE_URL } from 'constants/urls';
import { detectMob } from 'utils/detectMob';

//?productId=9d310f1d-32b6-4d89-8fb0-7baf34b22d22&pointId=17fa028a-7b36-4447-bf05-eb4ab5dfe45a

export const CustomRoute: FC<RouteProps> = observer(({ isPrivate, children }) => {
  const {
    mainStore: { token, redirectUrls },
    alertStore: { show, hideAlert },
  } = useStore();

  const location = useLocation();

  useEffect(() => {
    if (show) hideAlert();
  }, []);

  const shareDataHandle = useCallback((search: string) => {
    if (detectMob()) {
      const timeStamp = `&time=${+new Date()}`;
      const url = MOBILE_URL + search + timeStamp;
      window.location.assign(url);
      return <>{children}</>;
    }
  }, []);

  if (location.pathname === '/share/product') {
    const { search } = location;
    return search.includes('pointId') && search.includes('productId') ? (
      shareDataHandle(search) || <div>Sorry we don't support this device</div>
    ) : (
      <Navigate to='/login' replace />
    );
  } else if (location.pathname === '/share/point') {
    const { search } = location;
    return search.includes('pointId') ? (
      shareDataHandle(search) || <div>Sorry we don't support this device</div>
    ) : (
      <Navigate to='/login' replace />
    );
  } else if (isPrivate && !token) {
    return <Navigate to='/login' replace />;
  } else if (token && (location.pathname === '/login' || location.pathname === '/')) {
    return <Navigate to={redirectUrls} replace />;
  } else return <>{children}</>;
});
